import Vue from 'vue'
import App from './App.vue'
import { i18n } from './i18n'
import { ApmVuePlugin } from '@elastic/apm-rum-vue'

import './directives/track' // 全局打点指令

Vue.config.productionTip = false

// 初始化elastic-apm插件
Vue.use(ApmVuePlugin, {
  // router
  config: {
    serverUrl: process.env.VUE_APP_APM_SERVER_URL,
    serviceName: require('../package.json').name,
    serviceVersion: require('../package.json').version,
    environment: process.env.VUE_APP_ENV,
    active: process.env.NODE_ENV !== 'development'
  }
})

new Vue({
  i18n,
  render: (h) => h(App),
}).$mount('#app')
